import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import Target from '@/types/table/target';
import { TargetTitleData } from '@/api/generated/targetTitleController';
import { TargetItemData } from '@/api/generated/targetItemController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface TargetData extends Target {
  targetTitleList?: TargetTitleData[];
  targetItemList?: TargetItemData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class TargetController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<TargetData>>(
      API_CONTEXT + '/upms/target/list',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<TargetData>(API_CONTEXT + '/upms/target/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/target/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/target/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/target/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/target/add', params, httpOptions);
  }
  static detail(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<TargetData>(API_CONTEXT + '/upms/target/detail', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/target/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/target/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/target/deleteBatch', params, httpOptions);
  }
}
